import { createClient } from "@supabase/supabase-js";

const fallbackSupabaseUrl = "https://ewkjcthmtjnsmftwroxx.supabase.co";
const fallbackSupabaseAnonKey = "sb_publishable_bfQktTHBIRRuviB012FJyg_VaJTaUkU";

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string | undefined) || fallbackSupabaseUrl;
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) || fallbackSupabaseAnonKey;

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseAnonKey);
export const publicSupabaseUrl = supabaseUrl;

export const supabase = hasSupabaseConfig
  ? createClient(supabaseUrl!, supabaseAnonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : null;
